export default __webpack_public_path__ + "static/media/slider-arrow.5bf0b9f1.svg";